import { h } from 'preact'; /** @jsx h */

import './Content.scss';

const Content = ({ width = 'small', type = false, children, spaceY = false, spaceX = false }) => {
    return (
        <div
            className={`content content-${width} ${type && type} ${spaceY ? 'space-y' : ''} ${
                spaceX ? 'space-x' : ''
            }`}
        >
            {children}
        </div>
    );
};

export default Content;
